import { Heart } from "lucide-react";

export const Sparkle = ({ className = "", size = 18, delay = 0 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={`twinkle ${className}`} style={{ animationDelay: `${delay}s` }} aria-hidden>
    <path d="M12 0c.6 5.6 3.4 8.6 12 12-8.6 3.4-11.4 6.4-12 12-.6-5.6-3.4-8.6-12-12 8.6-3.4 11.4-6.4 12-12z" fill="#D4A537" />
  </svg>
);

export const StitchDivider = ({ pink = false, className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} aria-hidden>
    <div className={`flex-1 ${pink ? "stitch-line-pink" : "stitch-line"}`} />
    <Heart className="h-4 w-4 fill-[#FF1F8E] text-[#FF1F8E]" />
    <div className={`flex-1 ${pink ? "stitch-line-pink" : "stitch-line"}`} />
  </div>
);

export const ThreadLine = ({ className = "" }) => (
  <svg viewBox="0 0 800 200" className={className} fill="none" aria-hidden preserveAspectRatio="none">
    <path className="thread-draw" d="M0 150 C 150 20, 260 220, 400 110 S 650 10, 800 90" stroke="#FF1F8E" strokeWidth="2.5" strokeDasharray="10 8" strokeLinecap="round" />
    <path d="M0 165 C 160 40, 270 230, 410 125 S 660 25, 800 105" stroke="#D4A537" strokeWidth="1" opacity=".6" />
  </svg>
);

export const Tagline = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <span className="font-script">Loving Every Stitch</span>
    <Heart className="h-4 w-4 fill-[#FF1F8E] text-[#FF1F8E]" />
  </span>
);

export const SectionTitle = ({ eyebrow, title, script, light = false, testid }) => (
  <div className="max-w-2xl" data-testid={testid}>
    {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
    <h2 className={`font-display text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-[#0E0B0D]"}`}>
      {title} {script && <span className="font-script font-normal text-[#FF1F8E]">{script}</span>}
    </h2>
  </div>
);

export const TikTokIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
    <path d="M19.6 6.7a4.8 4.8 0 0 1-3.8-4.2V2h-3.4v13.4a2.9 2.9 0 1 1-2-2.7V9.2a6.3 6.3 0 1 0 5.4 6.2V8.6a8.2 8.2 0 0 0 3.8 1V6.7z" />
  </svg>
);
